import { render } from "./DataLegalDialog.vue?vue&type=template&id=8c68f10a"
import script from "./DataLegalDialog.vue?vue&type=script&lang=js"
export * from "./DataLegalDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__